import * as S from "./style";
import axiosInstance from "../../services/axiosInstance";
import { useEffect, useState } from "react";
//Components
import TotalItems from '../../components/DashboardSection/TotalItems';
import TitleHeaderCashFlow from "../../components/Title/TitleCashFlow";
import ButtonFilterTable from "../../components/Button/ButtonFilterTable";
import Footer from "../../components/Footer";
import PopMenu from "../../components/PopMenuTable";
import DetailsExpense from "../../components/Modals/Expense/Details";
import DetailsOrder from "../../components/Modals/Order/Details";
import Loading from "../../components/Loading";
import useLoading from "../../hooks/useLoading";
import Auth401 from "../../components/Error/Auth";
import Erro429 from "../../components/Error/Erro429";
import FilterTable from "../../components/Filter/FilterTable";
// Icon
import { FiMoreVertical } from "react-icons/fi";
import { List } from "@phosphor-icons/react";
// Hooks
import NoData from "../../components/NoData";
import { useMultipleModal } from "../../hooks/useMultipleModal";
// utils
import FormatarData from "utils/FormatData";
import { CurrencyFormat } from "utils/CurrencyFormat";
// Interface
import { ICash } from "Interfaces/ICashFlow";
import { IPage } from "Interfaces/IPage";

export default function CashFlow() {
  const [data, setData] = useState<ICash['data'][]>([]);
  const [dashboard, setDashboard] = useState<ICash['panel'] | null>(null);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const [page, setCurrentPage] = useState<IPage>({
    id: 0,
    last_page: 0,
    current_page: 0,
    total: 0,
  });
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const { isLoading, startLoading, stopLoading } = useLoading();

  type FilterLinkType = string | { day: string; month: string; year: string };
  const [activeFilter, setActiveFilter] = useState<'gains' | 'expenses'>('gains');
  const [filterLink, setFilterLink] = useState<FilterLinkType>();

  const [filters, setFilters] = useState({
    status: "",
    category: "",
  });

  const [headerTable, setHeaderTable] = useState({
    gains: [
      { name: '#', filter: false },
      { name: 'Data da transação', filter: false },
      { name: 'Status', filter: true, data: [], url: 'status', api: 'status', activeFilter: false },
      { name: 'Valor R$', filter: false },
      { name: 'Ações', filter: false },
    ], expenses: [
      { name: '#', filter: false },
      { name: 'Data da transação', filter: false },
      { name: 'Nome', filter: false },
      { name: 'Categoria', filter: true, data: [], url: 'category', api: 'category', activeFilter: false },
      { name: 'Valor R$', filter: false },
      { name: 'Ações', filter: false },
    ]
  });

  const typeHeader = activeFilter === 'expenses' ? headerTable.expenses : headerTable.gains;

  const menuItemsPop = [
    {
      icon: <List size={16} />,
      title: "Detalhes",
      isActive: false,
      path: activeFilter === 'expenses' ? "details-expense" : "details-order"
    },
  ];

  const handleMenuClick = (path: string) => {
    toggleModalVisibility(path);
  };

  const clickPopTable = (id: number) => {
    setOpenModalOptId(id);
    toggleModalVisibility("menu");
  };

  const handleFilterChange = (filter: 'gains' | 'expenses') => {
    setActiveFilter(filter);

    setFilters(() => ({
      category: '',
      status: ''
    }));
  };

  const handleSetPopMenuList = (filterType: string, value: any) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterType]: value,
    }));

    // Atualizar o headerTable para marcar o filtro como ativo
    setHeaderTable(prevHeaders => {
      // Criar uma cópia profunda do objeto headerTable
      const updatedHeaders = {
        gains: [...prevHeaders.gains],
        expenses: [...prevHeaders.expenses]
      };

      // Encontrar e atualizar o header específico
      updatedHeaders[activeFilter] = updatedHeaders[activeFilter].map(header =>
        header.api === filterType
          ? { ...header, activeFilter: value ? value : false }
          : header
      );

      // Determinar qual é o outro tipo de filtro e seu correspondente activeFilter
      const otherFilterType = filterType === "status" ? "category" : "status";
      const otherActiveFilter = filterType === "status" ? "expenses" : "gains";

      // Resetar o activeFilter do outro filtro
      updatedHeaders[otherActiveFilter] = updatedHeaders[otherActiveFilter].map(header =>
        header.api === otherFilterType
          ? { ...header, activeFilter: false }
          : header
      );

      console.log('updatedHeaders', updatedHeaders[otherActiveFilter]);

      return updatedHeaders;
    });
  };

  const extractFilterData = (responseData: ICash['data'][]) => {
    let updatedFilterData: string[] = [];

    // Recebendo a lista de filtros
    if (activeFilter === 'expenses') {
      // Extrair categorias únicas para o filtro de categoria
      updatedFilterData = responseData
        .map(item => item.category_expenses.category_expense)
        .filter((value, index, self) => value && self.indexOf(value) === index);
    } else {
      // Extrair status únicos para o filtro de status
      updatedFilterData = responseData
        .map(item => item.status)
        .filter((value, index, self) => value && self.indexOf(value) === index);
    }

    const updatedHeader = {
      ...headerTable,
      [activeFilter]: headerTable[activeFilter].map(header => {
        if (header.filter && header.api) {
          return {
            ...header,
            data: updatedFilterData,
          };
        }
        return header;
      }),
    };

    setHeaderTable(updatedHeader);
  };

  const fetchData = async () => {
    startLoading();
    try {
      let url = `cash-flow?page=${page.current_page}`

      if (
        typeof filterLink === 'object'
        && filterLink !== null
        && 'day' in filterLink
        && 'month' in filterLink
        && 'year' in filterLink
      ) {
        const { day, month, year } = filterLink;
        url += `&date=${year}-${month}-${day}`;
      }

      if (activeFilter === 'expenses') {
        url += `&filter=expenses`;
      }

      // Adicionar filtros à URL
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          url += `&${key}=${value}`;
        }
      });
      const response = await axiosInstance.get(url);
      const dataResponse = response.data.data;
      console.log('url: ', url);
      console.log('filters: ', filters);

      // Extrair os dados para os filtros
      extractFilterData(dataResponse.data);

      setData(dataResponse.data);
      setDashboard(response.data.panel);
      setCurrentPage(dataResponse);

    } catch (error: any) {
      if (error.status === 401) {
        toggleModalVisibility('auth');
      } else if (error.status === 429) {
        toggleModalVisibility('request429');
      }
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    const debounceFetch = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(debounceFetch);
  }, [filterLink, activeFilter, filters]);

  if (isOpenModal("auth")) {
    return (
      <Auth401 isOpen={isOpenModal("auth")} />
    )
  } else if (isOpenModal("request429")) {
    return (
      <Erro429 />
    )
  }

  return (
    <S.Container>
      <TitleHeaderCashFlow
        title="Registro de Fluxo de Caixa"
        subtitle="Gerencie o fluxo de caixa do sistema"
        onDataChange={setFilterLink}
      />
      {isLoading ? (
        <Loading />
      ) : (
        <S.Content>
          <S.ContentItems isFill={false}>
            <TotalItems name='Saldo diária' value={dashboard?.balance || '0'} />
            <TotalItems name='Entrada diária' value={dashboard?.gains || '0'} />
            <TotalItems name='Saída diária' value={dashboard?.expenses || '0'} />
            <TotalItems name='Retirada' value={dashboard?.withdrawal || '0'} />
          </S.ContentItems>

          <S.ContentButton>
            <ButtonFilterTable
              name_button="Entradas"
              isActive={activeFilter === 'gains'}
              onClick={() => handleFilterChange('gains')}
            />
            <ButtonFilterTable
              name_button="Saídas"
              isActive={activeFilter === 'expenses'}
              onClick={() => handleFilterChange('expenses')}
            />
          </S.ContentButton>

          <S.Table>
            <S.THead>
              <tr>
                {
                  typeHeader.map((header, index) => (
                    <th key={index}>
                      {
                        header.filter ?
                          (
                            <FilterTable
                              name={header.name}
                              data={header.data || []}
                              setPopMenuList={(value) =>
                                handleSetPopMenuList(header.api || '', value)
                              }
                              filterActive={!!header.activeFilter}
                            />
                          ) :
                          header.name
                      }
                    </th>
                  ))
                }
              </tr>
            </S.THead>

            <S.TBody>
              {
                data.length > 0 ? (
                  data.map((val, index) => (
                    <tr key={index}>
                      <td>{index + 1 || '-'}</td>
                      <td>{
                        FormatarData(val.date_sale, 'default') ||
                        FormatarData(val.date_proof, 'default') || '-'}</td>
                      {
                        val.title &&
                        <td>{val.title || '-'}</td>
                      }
                      <td>
                        <S.HighlightedField>

                          {
                            val.status ||
                            val.category_expenses?.category_expense ||
                            '-'
                          }
                        </S.HighlightedField>
                      </td>
                      <td>{CurrencyFormat(parseFloat(val.total_amount || '0'))}</td>
                      <S.TdPopMenu>
                        <S.ContentPopMenu>
                          <S.ButtonTable onClick={() => clickPopTable(val.id)}>
                            <FiMoreVertical />
                          </S.ButtonTable>
                        </S.ContentPopMenu>
                        {isOpenModal("menu") && openModalOptId === val.id && (
                          <div ref={(ref) => assignRef("menu", ref)}>
                            <PopMenu menuItems={menuItemsPop} onClickTable={handleMenuClick} />
                          </div>
                        )}
                      </S.TdPopMenu>
                    </tr>
                  ))
                ) :
                  <NoData />
              }
            </S.TBody>
          </S.Table>
        </S.Content>
      )
      }

      {
        page && (
          <Footer
            fetchData={fetchData}
            currentPage={page.current_page}
            lastPage={page.last_page}
            allPerPage={page.total}
          />
        )
      }

      <DetailsOrder
        isOpenModalDetails={isOpenModal("details-order")}
        setModalClose={() => toggleModalVisibility("details-order")}
        selectedUrlId={openModalOptId}
      />

      <DetailsExpense
        isOpenModal={isOpenModal("details-expense")}
        setModalClose={() => toggleModalVisibility("details-expense")}
        selectedUrlId={openModalOptId}
      />
    </S.Container >
  );
}
